import { render, staticRenderFns } from "./NewsMatrix.vue?vue&type=template&id=6d653cf3&"
import script from "./NewsMatrix.vue?vue&type=script&lang=js&"
export * from "./NewsMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports